import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'sitewide-jquery';

const modalBasePropTypes = {
  modalWrapperClass: PropTypes.string,
  modalViewClass: PropTypes.any.isRequired,
  modalViewParams: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  modalId: PropTypes.string,
  // Setting this to true will prevent clicking outside the modal
  // from dismissing it.
  disableBgClick: PropTypes.bool,
  // Override to set a custom width
  width: PropTypes.number,
  // Override to set a custom max width
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // Center the modal horizontally, just above center vertically
  center: PropTypes.bool,
  // Make modal full height
  fullHeight: PropTypes.bool,

  // Override to style the modal-dialog element
  modalClassName: PropTypes.string,

  // The modal-content class applies a white background and box shadow
  // to the modal removing this class is useful when animating a modal
  // for control over this background
  disableModalContentClass: PropTypes.bool,
};

// after much fighting with ModalBase it looks like
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/32588 means that making ModalBase
// generic won't work as long as we use propTypes
export type AddedProps = {
  closeModal: () => any;
  addWillCloseListener: (listener: () => void) => void;
};

type ModalBaseProps = PropTypes.InferProps<typeof modalBasePropTypes>;
export default class ModalBase extends React.Component<ModalBaseProps> {
  static propTypes = modalBasePropTypes;

  static defaultProps = {
    disableBgClick: false,
    disableModalContentClass: false,
    modalClassName: '',
    center: false,
    fullHeight: false,
  };

  element: any;
  willCloseListeners: (() => void)[] = [];

  componentDidMount() {
    this.element = $('#' + this.props.modalId);
    // This gets the container created by showModal in show_modal.tsx
    // and makes it a bootstrap modal via jquery plugin
    this.element.modal('show');
    // This custom event is fired by bootstrap when closed,
    // so we need to handle the close in react here aswell
    return this.element.on('hidden.bs.modal', this.handleClose);
  }

  handleClose = () => {
    this.props.onClose();
    this.willCloseListeners.forEach((l) => l());
  };

  close = () => {
    this.willCloseListeners.forEach((l) => l());
    return this.element.modal('hide');
  };

  handleAddWillCloseListener = (listener: () => void) => {
    this.willCloseListeners.push(listener);
  };

  renderModalView = () => {
    const params = {
      closeModal: this.close,
      addWillCloseListener: this.handleAddWillCloseListener,
      ...this.props.modalViewParams,
    };
    return React.createElement(this.props.modalViewClass, params);
  };

  render() {
    const backdrop = this.props.disableBgClick ? 'static' : true;
    const modalContentClass = this.props.disableModalContentClass
      ? ''
      : 'modal-content';
    const styles = this.props.center
      ? {
          margin: 0,
          width: this.props.width,
          maxWidth: this.props.maxWidth,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -55%)',
          maxHeight: 'calc(100vh - 5% - 40px)', // Prevents translating past top of window
        }
      : { width: this.props.width, maxWidth: this.props.maxWidth };

    let modalContentStyles = {};
    if (this.props.fullHeight) {
      modalContentStyles = { height: '100%' };
    }

    return (
      // Use tabIndex="-1" so the modal receives keyboard events first and
      // can react to "esc" for closing
      <div
        className={classNames(
          'ds-Modal',
          'modal',
          this.props.modalWrapperClass,
        )}
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        id={this.props.modalId}
        tabIndex={-1}
        data-backdrop={backdrop}
      >
        <div
          className={'modal-dialog ' + this.props.modalClassName}
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ margin: number; width: number | null | und... Remove this comment to see the full error message
          style={styles}
        >
          <div className={modalContentClass} style={modalContentStyles}>
            {this.renderModalView()}
          </div>
        </div>
      </div>
    );
  }
}
